<template>
  <div>
    <v-row
      row
      wrap
      no-gutters
      justify-start
      class="mb-5"
      v-if="$vuetify.breakpoint.lg || $vuetify.breakpoint.md"
    >
      <!-- <v-col cols="1" md="1" xs="1" sm="1"></v-col> -->
      <v-col cols="6" md="6" xs="6" sm="6" class="mt-n4">
        <v-form ref="form">
          <div style="background-color: #ffffff; height: 100%; width: 100%; opacity: 0.9">
            <v-row no-gutters>
              <v-col cols="2" md="2" xs="2" sm="2"></v-col>
              <v-col cols="10" md="10" xs="10" sm="10">
                <div
                  class="pt-12 mt-8 text-left"
                  style="
                    font-family: Ebrima;
                    font-style: normal;
                    font-weight: 700;
                    font-size: 38px;
                    line-height: 48px;
                    color: #0b3a8f;
                  "
                >
                  {{ $t("loginpage.login") }}
                </div>
                <div
                  class="text-left"
                  style="
                    font-family: Ebrima;
                    font-style: normal;
                    font-weight: 400;
                    font-size: 18px;
                    color: #a1a1a1;
                    line-height: 22px;
                  "
                >
                  ONE Conference Anywhere Anytime
                </div>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="1" md="2" xs="1" sm="1"></v-col>
              <!-- :placeholder= "$t('loginpage.username')" -->
              <v-col cols="11" md="9" xs="11" sm="11" class="">
                <v-text-field
                  :oninput="onlyuser"
                  outlined
                  dense
                  v-model="username"
                  rounded
                  :prefix="$t('loginpage.username')"
                  @keypress="userpassword"
                  append-icon="mdi-account"
                ></v-text-field>
                <v-text-field
                  :oninput="onlypass"
                  outlined
                  dense
                  v-model="password"
                  rounded
                  @keypress="userpassword"
                  v-on:keyup="enterToLogInOneId"
                  :prefix="$t('loginpage.password')"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show1 ? 'text' : 'password'"
                  @click:append="show1 = !show1"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="1" md="2" xs="1" sm="1"></v-col>
              <v-col
                cols="12"
                md="8"
                xs="12"
                sm="12"
                class="pl-2 pointer"
                @click="forgotPassword"
              >
                <span
                  style="
                    font-family: IrisUPC;
                    font-style: normal;
                    font-weight: 400;
                    font-size: 20px;
                    color: #a1a1a1;
                    line-height: 22px;
                    text-decoration: underline;
                  "
                >
                  {{ $t("loginpage.forgotpassword") }}?
                </span>
              </v-col>
            </v-row>
            <v-row no-gutters class="pl-4">
              <v-col cols="1" md="2" xs="1" sm="1" class=""></v-col>
              <v-col cols="11" md="1" xs="11" sm="11" class="pl-6">
                <v-checkbox
                  color="#00BFA5"
                  value="success"
                  hide-details
                  v-model="checkbox"
                >
                </v-checkbox>
              </v-col>
              <v-col
                cols="12"
                md="9"
                xs="12"
                sm="12"
                class="pt-5 pr-14"
                style="font-size: 14px"
              >
                <span>
                  {{ $t("loginpage.Accept") }}
                </span>
                <span
                  class="pointer"
                  @click="PrivacyNotice()"
                  style="color: #2083e4; cursor: pointer"
                >
                  {{ $t("loginpage.oneid") }}
                </span>
                <span>
                  {{ $t("loginpage.and") }}
                </span>
                <span
                  class="pointer"
                  @click="ProtectionPolicy()"
                  style="color: #2083e4; cursor: pointer"
                >
                  {{ $t("loginpage.Privacy") }}
                </span>
              </v-col>
            </v-row>
            <div class="mx-3 pt-5">
              <v-row row wrap no-gutters justify-start>
                <v-col cols="1" lg="2" md="2" xs="1" sm="1"></v-col>
                <v-col cols="11" lg="9" md="9" xs="11" sm="11">
                  <v-btn
                    depressed
                    block
                    rounded
                    color="#3D85C6"
                    style="color: white"
                    @click="loginoneid()"
                    :disabled="Disabled"
                    :loading="loadingApiLogin"
                  >
                    {{ $t("loginpage.login") }}
                  </v-btn>
                </v-col>
              </v-row>
              <v-row row wrap no-gutters justify-start class="pt-2">
                <v-col cols="1" lg="2" md="2" xs="1" sm="1"></v-col>
                <v-col cols="11" lg="9" md="9" xs="11" sm="11">
                  <v-btn
                    depressed
                    @click="gojoinpage()"
                    block
                    rounded
                    outlined
                    color="primary"
                  >
                    <v-icon>mdi-video-plus-outline</v-icon>
                    {{ $t("loginpage.joinin") }}
                  </v-btn>
                </v-col>
              </v-row>
              <!-- <v-row row wrap justify-start>
                <v-col cols="2" lg="2"></v-col>
                <v-col cols="3" lg="3" class="float-rigth ma-2">
                  <b><v-divider class="vDivider"/></b>
                </v-col>
                <v-col
                  cols="2"
                  lg="2"
                  class="text-center ma-4 detailVider"
                  style="color: #A1A1A1;"
                >
                  <b>หรือ Login with</b>
                </v-col>
                <v-col cols="3" lg="3" class="float-rigth ma-2">
                  <b><v-divider class="vDivider"/></b>
                </v-col>
              </v-row> -->
              <!-- <v-row row wrap no-gutters justify-center>
                            <v-col cols="12" lg="9" md="8" xs="12" sm="12" class="text-center">
                                <v-avatar color="#0B3A8F" style="color:white;" >
                                    <v-icon dark>
                                        mdi-email-outline
                                    </v-icon>
                                </v-avatar>
                                <span class="pl-3">ONE COLLABORATION MAIL</span>
                            </v-col>
                        </v-row> -->
              <v-row row wrap no-gutters justify-center class="mt-4">
                <v-col cols="1" lg="2" md="2" xs="12" sm="12" class="text-center"></v-col>
                <v-col cols="11" lg="9" md="8" xs="11" sm="11" class="text-center">
                  <span class="">{{ $t("loginpage.notuser") }} ?</span>
                  <span
                    class="pl-1 pointer"
                    @click="openModelSignup"
                    style="color: #00daad; font-size: 16px; text-decoration: underline"
                    >{{ $t("loginpage.Register") }}</span
                  >
                </v-col>
              </v-row>
              <!-- <v-row row wrap no-gutters justify-center class="mt-4">
                <v-col
                  cols="1"
                  lg="2"
                  md="2"
                  xs="12"
                  sm="12"
                  class="text-center"
                ></v-col>
                <v-col
                  cols="11"
                  lg="9"
                  md="8"
                  xs="11"
                  sm="11"
                  class="text-center"
                >
                  <span class="" style="font-size: 16px;">{{$t("loginpage.oldversion") }}</span>
                  <span class="pl-1 pointer" @click="backtomeet1" style="color:#0C2FE0; font-size: 16px; text-decoration: underline;">{{$t("loginpage.click") }}</span>
                </v-col>
              </v-row> -->
            </div>
          </div>
        </v-form>
      </v-col>
    </v-row>
    <v-row
      row
      wrap
      no-gutters
      justify-start
      class="mb-5"
      v-if="$vuetify.breakpoint.xl || $vuetify.breakpoint.xxl"
    >
      <!-- <v-col cols="1" md="1" xs="1" sm="1"></v-col> -->
      <v-col cols="6" md="6" xs="6" sm="6" class="mt-n4">
        <v-form ref="form">
          <div
            style="background-color: #ffffff; height: 800px; width: 100%; opacity: 0.9"
          >
            <v-row no-gutters>
              <v-col cols="2" md="2" xs="2" sm="2"></v-col>
              <v-col cols="10" md="10" xs="10" sm="10">
                <div
                  class="mt-12 pt-10 text-left"
                  style="
                    font-family: Ebrima;
                    font-style: normal;
                    font-weight: 700;
                    font-size: 42px;
                    line-height: 48px;
                    color: #0b3a8f;
                  "
                >
                  {{ $t("loginpage.login") }}
                </div>
                <div
                  class="text-left"
                  style="
                    font-family: Ebrima;
                    font-style: normal;
                    font-weight: 400;
                    font-size: 22px;
                    color: #a1a1a1;
                    line-height: 30px;
                  "
                >
                  ONE Conference Anywhere Anytime
                </div>
              </v-col>
            </v-row>
            <v-row no-gutters class="pt-7">
              <v-col cols="1" md="2" xs="1" sm="1"></v-col>
              <v-col cols="11" md="9" xs="11" sm="11" class="">
                <!-- :placeholder="$t('loginpage.username')" -->
                <v-text-field
                  :oninput="onlyuser"
                  outlined
                  dense
                  v-model="username"
                  rounded
                  :prefix="$t('loginpage.username')"
                  @keypress="userpassword"
                  append-icon="mdi-account"
                ></v-text-field>
                <!-- :placeholder="$t('loginpage.password')" -->
                <v-text-field
                  :oninput="onlypass"
                  outlined
                  dense
                  v-model="password"
                  rounded
                  v-on:keyup="enterToLogInOneId"
                  @keypress="userpassword"
                  :prefix="$t('loginpage.password')"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show1 ? 'text' : 'password'"
                  @click:append="show1 = !show1"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="1" md="2" xs="1" sm="1"></v-col>
              <v-col
                cols="12"
                md="8"
                xs="12"
                sm="12"
                class="pl-2 pointer"
                @click="forgotPassword"
              >
                <span
                  style="
                    font-family: IrisUPC;
                    font-style: normal;
                    font-weight: 400;
                    font-size: 26px;
                    color: #a1a1a1;
                    line-height: 22px;
                    text-decoration: underline;
                  "
                >
                  {{ $t("loginpage.forgotpassword") }}?
                </span>
              </v-col>
            </v-row>
            <v-row no-gutters class="pl-4">
              <v-col cols="1" md="2" xs="1" sm="1" class=""></v-col>
              <v-col cols="11" md="1" xs="11" sm="11" class="">
                <v-checkbox
                  color="#00BFA5"
                  value="success"
                  hide-details
                  v-model="checkbox"
                >
                </v-checkbox>
              </v-col>
              <v-col
                cols="12"
                md="7"
                xs="12"
                sm="12"
                class="pt-4"
                style="font-size: 14px"
              >
                <span>
                  {{ $t("loginpage.Accept") }}
                </span>
                <span
                  class="pointer"
                  @click="PrivacyNotice()"
                  style="color: #2083e4; cursor: pointer"
                >
                  {{ $t("loginpage.oneid") }}
                </span>
                <span>
                  {{ $t("loginpage.and") }}
                </span>
                <span
                  class="pointer"
                  @click="ProtectionPolicy()"
                  style="color: #2083e4; cursor: pointer"
                >
                  {{ $t("loginpage.Privacy") }}
                </span>
              </v-col>
              <!-- <v-col cols="12" md="7" xs="12" sm="12" class="pt-4">
                <span class="pointer" @click="openModalTermOfUser" style="font-size: 20px;"
                  >{{$t("loginpage.oneid") }}</span
                >
              </v-col> -->
            </v-row>
            <div class="mx-3 pt-5">
              <v-row row wrap no-gutters justify-start>
                <v-col cols="1" lg="2" md="2" xs="1" sm="1"></v-col>
                <v-col cols="11" lg="9" md="9" xs="11" sm="11">
                  <v-btn
                    depressed
                    block
                    rounded
                    color="#3D85C6"
                    style="color: white"
                    @click="loginoneid()"
                    :disabled="Disabled"
                    :loading="loadingApiLogin"
                  >
                    {{ $t("loginpage.login") }}
                  </v-btn>
                </v-col>
              </v-row>
              <v-row row wrap no-gutters justify-start class="pt-2">
                <v-col cols="1" lg="2" md="2" xs="1" sm="1"></v-col>
                <v-col cols="11" lg="9" md="9" xs="11" sm="11">
                  <v-btn
                    depressed
                    @click="gojoinpage()"
                    block
                    rounded
                    outlined
                    color="primary"
                  >
                    <v-icon>mdi-video-plus-outline</v-icon>
                    {{ $t("loginpage.joinin") }}
                  </v-btn>
                </v-col>
              </v-row>
              <v-row row wrap no-gutters justify-center class="mt-4">
                <v-col cols="1" lg="2" md="2" xs="12" sm="12" class="text-center"></v-col>
                <v-col cols="11" lg="9" md="8" xs="11" sm="11" class="text-center">
                  <span class="" style="font-size: 20px"
                    >{{ $t("loginpage.notuser") }} ?</span
                  >
                  <span
                    class="pl-1 pointer"
                    @click="openModelSignup"
                    style="color: #00daad; font-size: 20px; text-decoration: underline"
                    >{{ $t("loginpage.Register") }}</span
                  >
                </v-col>
              </v-row>
              <!-- <v-row row wrap no-gutters justify-center class="mt-4">
                <v-col
                  cols="1"
                  lg="2"
                  md="2"
                  xs="12"
                  sm="12"
                  class="text-center"
                ></v-col>
                <v-col
                  cols="11"
                  lg="9"
                  md="8"
                  xs="11"
                  sm="11"
                  class="text-center"
                >
                  <span class="" style="font-size: 20px;">{{$t("loginpage.oldversion") }}</span>
                  <span class="pl-1 pointer" @click="backtomeet1" style="color:#0C2FE0; font-size: 20px; text-decoration: underline;">{{$t("loginpage.click") }}</span>
                </v-col>
              </v-row> -->
            </div>
          </div>
        </v-form>
      </v-col>
      <!-- <v-col cols="1" md="1" xs="1" sm="1"></v-col> -->
    </v-row>
    <!-- <Footer /> -->
  </div>
</template>
<script>
import CryptoJS from "crypto-js";
import { mapState, mapActions } from "vuex";
// import Footer from "../Footer.vue";

export default {
  components: {
    // Footer
  },
  data() {
    return {
      onlyuser:
        "this.value = this.value.replace(/[^0-9a-zA-Z!().,`|_;:@#$%&*~+-/?]|/g, '')",
      onlypass:
        "this.value = this.value.replace(/[^0-9a-zA-Z!(){}''.|=`<>,^_;:@#$%&*~+-/?]|/g, '')",
      username: "",
      password: "",
      Disabled: true,
      jwt: require("jsonwebtoken"),
      show1: false,
      loadingApiLogin: false,
      checkbox: false,
      sharetoken: "",
      usertoken: "",
    };
  },
  watch: {
    checkbox(value) {
      if (value) {
        this.conditionDialbleBtnLogin();
      } else {
        this.Disabled = true;
      }
    },
  },
  created() {
    this.uuid = this.$route.query.uuid;
    this.sharetoken = this.$route.query.sharetoken;
    // console.log('sharetoken', this.sharetoken)
    if (
      this.sharetoken === "" ||
      this.sharetoken === undefined ||
      this.sharetoken === null
    ) {
      // console.log('sharetoken null', this.sharetoken)
      // console.log('env', process.env.VUE_APP_POLICIES)
      if (localStorage.getItem("user-token") === null) {
        // console.log('user-token')
        localStorage.removeItem("user-token");
      } else {
        // this.checkrole()
        // this.goPage("/activate");
        this.goPage("/manage");
      }
    } else {
      this.sharetokenoneplatform();
    }
    this.$multiwatch(["username", "password"], function () {
      const valid = this.$refs.form.validate();
      if (this.checkbox === true) {
        this.Disabled = !valid;
      }
    });
  },
  computed: {
    ...mapState("dialog", ["switchSigninSignup"]),
  },
  methods: {
    ...mapActions("dialog", ["setSwitchSignSignup"]),
    openModalTermOfUser() {
      window.open(process.env.VUE_APP_ONEID + "/api/term-of-use", "_blank");
    },
    forgotPassword() {
      window.open(process.env.VUE_APP_ONEID + "/type_forgot_password", "_blank");
    },
    gojoinpage() {
      this.$router.push({ path: "/joinpage" }).catch(() => {});
    },
    async downloadAdmin() {
      try {
        await this.axios
          .get(process.env.VUE_APP_API + "/api/v1/download/manualBusiness", {
            responseType: "arraybuffer",
          })
          .then((res) => {
            const blob = new Blob([res.data], { type: "application/pdf" });
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "Manual_One_Conference_Service_Business.pdf";
            link.click();
          });
      } catch (error) {
        console.log("Manual_One_Conference_Service_Business", error);
      }
    },
    async downloadAttendee() {
      try {
        await this.axios
          .get(process.env.VUE_APP_API + "/api/v1/download/manualCitizen", {
            responseType: "arraybuffer",
          })
          .then((res) => {
            const blob = new Blob([res.data], { type: "application/pdf" });
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "Manual_One_Conference_Service_Citizen.pdf";
            link.click();
          });
      } catch (error) {
        console.log("ManualAttendeeBusiness", error);
      }
    },
    userpassword(e) {
      // only english and number
      const key = e.which ? e.which : e.keyCode;
      if (key >= 33 && key <= 64) {
        return true;
      } // number
      if (key >= 65 && key <= 90) {
        return true;
      } // A-Z
      if (key >= 91 && key <= 125) {
        return true;
      } // a-z
      return e.preventDefault();
    },
    PrivacyNotice() {
      window.open(process.env.VUE_APP_POLICIES + "?" + "tabs=" + 0, "_blank");
    },
    ProtectionPolicy() {
      window.open(process.env.VUE_APP_POLICIES + "?" + "tabs=" + 1, "_blank");
    },
    openModelSignup() {
      this.setSwitchSignSignup(true);
    },
    backtomeet1() {
      window.open("https://meet1.one.th", "_blank");
    },
    loginoneid() {
      if (this.username === "" && this.password === "") {
        // this.$swal('Please, enter "Username" and "Password"', "", "warning");
        this.$swal(
          this.$t("loginpage.Pleaseenter") + this.$t("loginpage.usernameorpass"),
          "",
          "warning"
        );
      } else if (this.username !== "" && this.password === "") {
        // this.$swal('Please, enter "Password"', "", "warning");
        this.$swal(
          this.$t("loginpage.Pleaseenter") + this.$t("loginpage.password"),
          "",
          "warning"
        );
      } else if (this.username === "" && this.password !== "") {
        // this.$swal('Please, enter "Username"', "", "warning");
        this.$swal(
          this.$t("loginpage.Pleaseenter") + this.$t("loginpage.username"),
          "",
          "warning"
        );
      } else {
        this.loadingApiLogin = true;
        this.Disabled = true;
        // const jwt = sign({username: this.username, password: this.password}, process.env.VUE_APP_SECRET_KEY);
        // this.encodeJS({username: this.username, password: this.password})
        this.encodeJS(
          JSON.stringify({ username: this.username, password: this.password })
        );
        // console.log(this.usertoken)
        this.axios
          .post(process.env.VUE_APP_API + "/api/lv1/auth/login", {
            token: this.usertoken,
          })
          .then((res) => {
            if (res.data.code === 200) {
              // console.log('200', res.data.data.token)
              if (res.data.result === "Success") {
                localStorage.setItem("user-token", res.data.data.token);
                localStorage.setItem("oneid-token", res.data.data.oneid);
                // localStorage.setItem(
                //   "access-token",
                //   res.data.data.oneid.access_token
                // );
                // localStorage.setItem( "refresh_token",  res.data.data.oneid.refresh_token );
                this.decodejwttoken(res.data.data.token);
                // this.$swal(res.data.message, "", "success");
                this.$swal.fire({
                   title: this.$t("loginpage.login"),
                   text: this.$t("loginpage.Successfully"),
                    icon: 'success',
                    showCancelButton: false,
                   confirmButtonText: this.$t("button.btnok"),
                   allowOutsideClick: false
                })
              } else {
                this.loadingApiLogin = false;
                this.Disabled = false;
                // this.$swal('aaaaaa', "", "warning");
                this.$swal(this.$t("loginpage.idpassincorrect"), "", "warning");
                // console.log('warning', res.data)
              }
            } else {
              // console.log('else', res.data)
              this.$swal(this.$t("loginpage.idpassincorrect"), "", "warning");
              this.loadingApiLogin = false;
              this.Disabled = false;
            }
          })
          .catch((e) => {
            // this.$swal("Unable to login invalid information", "ไม่สามารถเข้าสู่ระบบได้ข้อมูลไม่ถูกต้อง", "warning");
            this.$swal(this.$t("message.Unabletologin"), "", "warning");
            console.log("400", e);
            this.loadingApiLogin = false;
            this.Disabled = false;
          });
      }
    },
    encodeJS(data) {
      // console.log(data)
      try {
        var ciphertext = CryptoJS.AES.encrypt(
          JSON.stringify(data),
          process.env.VUE_APP_SECRET_KEY
        ).toString();
        this.usertoken = ciphertext;
        return ciphertext;
      } catch (error) {
        console.log(error);
        return error;
      }
    },
    sharetokenoneplatform() {
      this.$router.push({ path: "/loadinglogin" }).catch(() => {});
    },
    decodejwttoken(data) {
      var token = data;
      const decryptedText = this.CryptoJS.AES.decrypt(
        token,
        process.env.VUE_APP_SECRET_KEY
      )
        .toString(this.CryptoJS.enc.Utf8)
        .replace(/"/g, "");
      var data = this.jwt.decode(decryptedText);
      // var userData = data
      // console.log('this.userData', data.user._id)
      this.createthem(data.user._id);
    },
    createthem(userid) {
      this.loadingApiLogin = false;
      this.Disabled = false;
      // this.checkrole()
      if (this.$route.query.uuid === undefined) {
        // this.goPage("/activate");
        this.goPage("/manage");
      } else {
        this.goPage("/join/?uuid=" + this.uuid);
      }
      // this.axios
      //     .post(process.env.VUE_APP_API + "/api/v1/theme/create/", {
      //       user_id: userid
      // }).then(res => {
      //   if( res.data.result === 'Created' || res.data.result === 'Success'){
      //     this.loadingApiLogin = false;
      //     this.Disabled = false;
      //           // this.checkrole()
      //           if (this.$route.query.uuid === undefined) {
      //               // this.goPage("/activate");
      //               this.goPage("/manage");
      //             } else {
      //               this.goPage('/join/?uuid=' + this.uuid )
      //             }
      //           // console.log('Success', res.data)
      //   }
      // }).catch(err => {
      //   console.log('createidprofile', err.message)
      // })
    },
    goPage(link) {
      this.$router.push(link).catch(() => {});
    },
    conditionDialbleBtnLogin() {
      const valid = this.$refs.form.validate();
      if (valid === true) {
        this.Disabled = false;
      } else {
        this.Disabled = true;
      }
    },
    enterToLogInOneId: function (e) {
      if (e.keyCode === 13) {
        if (this.Disabled === true) {
          this.$swal(this.$t("loginpage.Accept"), this.$t("loginpage.oneid"), "warning");
        } else {
          this.loginoneid();
        }
      }
    },
  },
};
</script>
<style scoped>
.background {
  background-image: url("~@/assets/fram_bg.jpg");
  background-position: right;
  transform: translate(1px, 0px);
  height: 100%;
  width: 100%;
  left: 10%;
  background-repeat: no-repeat;
  background-size: cover;
}
.vDivider {
  width: 100%;
  background: #a1a1a1;
  border-bottom: 1px solid #a1a1a1;
}
.detailVider {
  font-size: 9.3px;
}
.bgTransparent {
  background-color: transparent !important;
}
.pointer {
  cursor: -webkit-grab;
  cursor: pointer;
}
</style>
